/**
 * Application
 *
 * @author dkvistgaard <dkvistgaard@vertic.com>
 */

// Framework
import BackboneView from '../framework/view';
import Modal from '../framework/modal';

// Importing views
import views from './views';

const App = new BackboneView();
App.start = function start() {
	this.trigger('start');
};

global.App = App;

// Initialize framework scripts
App.modal = new Modal();

App.on('start', () => {
	console.log('app start');

	// Initializing all views
	views.forEach((View) => {
		new View(); // eslint-disable-line no-new
	});
});

export default App;
